import { render, staticRenderFns } from "./bottonBar.vue?vue&type=template&id=2c18b5be&"
import script from "./bottonBar.vue?vue&type=script&lang=ts&"
export * from "./bottonBar.vue?vue&type=script&lang=ts&"
import style0 from "./bottonBar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports